import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/celebrities")({
  component: lazyRouteComponent(() => import("./-pages/admin.celebrities")),
  head: () => ({ meta: [{ title: "Lecmo · المشاهير المتعاقد معهم" }] }),
});
